module.exports = __webpack_public_path__ + "static/media/genericError.7bcf3417.gif";